export const PRIVACY_POLICY_LINK = 'https://www.udacity.com/en-eu/legal/privacy';
export const COOKIE_POLICY_LINK = 'https://www.udacity.com/en-eu/legal/cookie-policy#cookie-preference';
